// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"500":"b2c5b5b3","516":"550589e0","581":"ac2ccdfa","726":"c811392a","800":"b46aef9b","824":"abe7b441","965":"050cfdfc"}[chunkId] + ".chunk.js";
};